/* eslint-disable prettier/prettier */
import type {AxiosRequestConfig} from 'axios';
import {Parcels, Relocate, Status} from './interface';

export class DeleteParcelBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}`;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class DeleteParcelItemBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.parcelRequest.url = `/parcel-items/${id}`;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class GetAllParcelsRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/parcels',
    params: {},
  };

  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}`;
    return this;
  }

  ronadId(id: number) {
    this.parcelRequest.url = `/parcels/ronad/${id}`;
    return this;
  }
  params(params: object) {
    this.parcelRequest.params = params;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}
export class GetParcelsCountRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/parcels/count',
    params: {},
  };
  params(params: object) {
    this.parcelRequest.params = params;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}

export class GetAllParcelsReportRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/parcels/report',
    params: {},
  };

  params(params: object) {
    this.parcelRequest.params = params;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}

export class CreateParcelsRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/parcels',
    data: {},
  };

  data(data: Parcels) {
    this.parcelRequest.data = data;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}
export class CreateGroupingParcelsRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/parcels/uploadFile',
    data: {},
  };
  params(params: object) {
    this.parcelRequest.params = params;
    return this;
  }

  data(data: any) {
    this.parcelRequest.data = data;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}

export class CreateParcelsOtherTypeRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/parcels/other-type',
    data: {},
  };

  data(data: Parcels) {
    this.parcelRequest.data = data;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}

export class CreateParcelItemsRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/parcels',
    data: {},
  };

  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}/items`;
    return this;
  }

  data(data: Record<string, any>) {
    this.parcelRequest.data = data;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}

export class GetParcelInventoryItemsRequestBuilder {
  private readonly productsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/inventory-items',
    params: {},
  };

  params(params: object) {
    this.productsRequest.params = params;
    return this;
  }

  build() {
    return this.productsRequest;
  }
}

export class GetCardIndexRequestBuilder {
  private readonly cardIndexReq: AxiosRequestConfig = {
    method: 'GET',
    url: '/inventory-items/card-index',
    params: {},
  };

  params(params: object) {
    this.cardIndexReq.params = params;
    return this;
  }

  build() {
    return this.cardIndexReq;
  }
}

export class RelocateInventoryItemRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'POST',
    url: '/inventory-items/re-locate',
    data: {},
  };
  data(body: Relocate) {
    this.request.data = body;
    return this;
  }
  build() {
    return this.request;
  }
}

export class UpdateParcelsRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcels',
    data: {},
  };
  data(body: Parcels | number) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UpdateParcelsQCVIPRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcels',
    data: {},
    params: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}/update-qc`;
    return this;
  }
  params(params: any) {
    this.parcelRequest.params = params;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UpdateCustomizedOperationRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcels',
    data: {},
    params: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}/customized-operation`;
    return this;
  }
  data(data: any) {
    this.parcelRequest.data = data;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class updateGroupeParcelsStatusesRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcels',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/parcels/operator/${id}`;
    return this;
  }
  data(body: Parcels | number) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UpdateDeliveryCostRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcels',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}/delivery-cost`;
    return this;
  }
  data(body: number) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UpdateInventoryItemsRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/inventory-items/register',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/inventory-items/${id}/register`;
    return this;
  }
  data(body: Record<string, any>) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UnloadAllInventoryItemsRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcel-items/{parcelId}/unload-all',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/parcel-items/${id}/unload-all`;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UpdateInventoryItemsCheckedRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/inventory-items/${id}/check`;
    return this;
  }
  data(body: Record<string, any>) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class AssignInventoryItemToOrderItemRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/inventory-items/${id}/order-item`;
    return this;
  }
  data(body: Record<string, any>) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class DeleteInventoryItemFromOrderItemRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/inventory-items/${id}/order-item`;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class DeleteInventoryItemFromParcelItemRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/inventory-items/${id}/parcel-item`;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class AssignParcelToDriverRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'PUT',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.request.url = `/parcels/${id}/driver`;
    return this;
  }
  data(body: Record<string, any>) {
    this.request.data = body;
    return this;
  }
  build() {
    return this.request;
  }
}

export class LocateInventoryItemRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/inventory-items/${id}/locate`;
    return this;
  }
  data(body: Record<string, any>) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class DeleteByOperatorInventoryItemRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/inventory-items/${id}/delete-by-operator`;
    return this;
  }
  data(body: Record<string, any>) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UnDeleteInventoryItemRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/inventory-items/${id}/un-delete`;
    return this;
  }
  data(body: Record<string, any>) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class LocateAllInventoryItemsUnitRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: 'inventory-items/locate',
    data: {},
  };
  data(body: Record<string, any>) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UpdateParcelOperatorRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcels',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}/operator`;
    return this;
  }
  data(params: string) {
    this.parcelRequest.data = params;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UpdateParcelsStatusRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}/status`;
    return this;
  }
  data(body: Status) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class ResolveParcelConflictsStatusRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}/resolve-conflicts`;
    return this;
  }
  data(body: Status) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class UpdateMultiParcelStatusRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'PUT',
    url: '/inventory-items/status',
    data: {},
  };
  data(body: Status) {
    this.request.data = body;
    return this;
  }
  build() {
    return this.request;
  }
}

export class CancelParcelRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/parcels/${id}/cancel`;
    return this;
  }
  data(body: Status) {
    this.parcelRequest.data = {description: `${body}`};
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}

export class GetAllParcelItemsRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/parcel-items',
    params: {},
  };

  id(id: number) {
    this.parcelRequest.url = `/parcel-items/${id}`;
    return this;
  }
  params(params: object) {
    this.parcelRequest.params = params;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}

export class UpdateParcelItemsUnitRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcel-items',
    params: {},
  };

  id(id: number) {
    this.parcelRequest.url = `/parcel-items/${id}/unit`;
    return this;
  }
  params(params: object) {
    this.parcelRequest.params = params;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}

export class UpdateParcelItemsStatusRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcel-items',
    params: {},
  };

  id(id: number) {
    this.parcelRequest.url = `/parcel-items/${id}/status`;
    return this;
  }
  
  data(data: string) {
    this.parcelRequest.data = `"${data}"`;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}

export class UpdateParcelProdExpDateRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/parcel-items',
    params: {},
  };

  id(id: number) {
    this.parcelRequest.url = `/parcel-items/${id}/consumption`;
    return this;
  }
   params(params: object) {
    this.parcelRequest.params = params;
    return this;
  }
  data(data: string) {
    this.parcelRequest.data = data;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}
export class GetParcelItemsCountRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/parcel-items/count',
    params: {},
  };
  params(params: object) {
    this.parcelRequest.params = params;
    return this;
  }

  build() {
    return this.parcelRequest;
  }
}
